import { ON_USERS_LIST, ON_REGISTER_USER_DATA, ON_CUSTODY_CENTERS_LIST } from '../constants/ActionTypes';

const INIT_STATE = {
    usersList: 0,
    custodyCentersList: 0,
    registeredUser: {}
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case ON_USERS_LIST: {
            return { ...state, usersList: action.payload };
        }

        case ON_REGISTER_USER_DATA: {
            return { ...state, registeredUser: action.payload };
        }
        case ON_CUSTODY_CENTERS_LIST: {
            return { ...state, custodyCentersList: action.payload };
        }
        default:
            return state;
    }
}
